import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import CollabrativeImg from "../../Assets/Images/CollabrativeImg.png";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20, 
    flex: 1,
  },
  card: {
    marginBottom: 5, 
  },
  cardBlue: {
    backgroundColor: "#F1F8F1",
    padding: 10,
    borderRadius: 5,
    marginTop: "5px"
  },
  cardRed: {
    backgroundColor: "#FFF0EC",
    padding: 10,
    borderRadius: 5,
    marginTop: "2px"
  },
  title: {
    fontSize: "18px",
    lineHeight: "21px",
    fontWeight: "700",
    fontFamily: "Lato",
    color: "#426B88",
    marginBottom: "10px", 
    textAlign: "left",
  },
  subtitle: {
    fontSize: 12,
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#00577D",
    lineHeight: "18px",
    marginBottom: 4,
  },
  paragraph: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "700",
    color: "#00577D",
  },
  listItem: {
    fontSize: "12px",
    color: "#00577D",
    fontFamily: "Lato",
    lineHeight: "18px",
    fontWeight: "400",
    marginBottom: 2,
  },
  coverImage: {
    width: 80, 
    height: 80,
    marginRight: 10,
    resizeMode: "contain",
  },
  first: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    flex: 1, 
    fontSize: "12px",
    fontFamily: "Lato",
    lineHeight: "18px",
    fontWeight: "400",
    color: "#00577D",
  },
});

const GroupLeadershipStyleCollaborative = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
      COLLABORATIVE LEADERSHIP GROUPS
      </Text>

      <View style={styles.card}>
        <View style={styles.first}>
          <Image src={CollabrativeImg} style={styles.coverImage} />
          <Text style={styles.text}>
            Collaborative Leadership is an extension of the Heart quadrant.
            These types of leaders excel in creating environments where everyone
            feels important and valued. They lead in ways that foster a
            cooperative atmosphere and emphasize respect among team members,
            helping everyone perform their best.
          </Text>
        </View>
      </View>

      <Text style={styles.paragraph}>
        Often referred to as "the People’s Leader," these individuals focus
        first on relationships and may be naturally attuned to understanding and
        constructively managing the feelings, wants, and needs happening beneath
        the surface. 
      </Text>
    <Text style={styles.paragraph}>
        This makes them empathetic and considerate, but they need
        to be careful not to get too caught up in people's issues to the point
        where it derails objectives and overrides healthy boundaries. At the
        heart of collaborative leadership is the belief that working together
        brings better results than working alone: "If you want to go fast, go
        alone. If you want to go far, go together."
    </Text>
      <View style={styles.cardBlue}>
        <Text style={styles.subtitle}>
        POSSIBLE CONTRIBUTIONS OF COLLABORATIVE LEADERSHIP GROUPS
        </Text>
        <Text style={styles.listItem}>
          • Collaborative Leadership Groups empower team members by delegating authority and encouraging initiative, which boosts confidence and accountability. 
        </Text>
        <Text style={styles.listItem}>
          • They excel at bridging interdepartmental gaps, aligning diverse interests and goals to enhance cooperation and reduce silos. Their approach to stakeholder engagement builds trust and fosters strong relationships crucial for success. 
        </Text>
        <Text style={styles.listItem}>
          • These groups cultivate a positive culture that values teamwork, respect, and diversity, making the workplace more welcoming and productive. Additionally, their leadership style enhances morale and job satisfaction, making employees feel valued and reducing turnover.
        </Text>
      </View>

      <View style={styles.cardRed}>
        <Text style={styles.subtitle}>
        POSSIBLE CHALLENGES FOR COLLABORATIVE LEADERSHIP GROUPS
        </Text>
        <Text style={styles.listItem}>
          • Despite their strengths, Collaborative Leadership Groups face several challenges. Emphasizing consensus can lead to groupthink, where the desire for harmony results in irrational or dysfunctional decisions. Their consensus-driven approach may also slow down decision-making, especially in critical situations. 
        </Text>
        <Text style={styles.listItem}>
          • The focus on relationships and feelings can risk losing objectivity and becoming overly involved in personal issues. Addressing underperformance can be challenging as they prioritize maintaining positive relationships. 
        </Text>
        <Text style={styles.listItem}>
          • Finally, collaborative approaches often require more time and resources, posing challenges in resource management without compromising other areas.
        </Text>
      </View>
    </View>
  );
};

export default GroupLeadershipStyleCollaborative;
